import type { StateCreator } from 'zustand';

export interface SharedData {
  accessToken: string;
  residentId: string;
  facilityId: string;
  userId: string;
  ssoId: string;
}

export interface SharedSlice {
  shared: SharedData;
  setSharedData: (data: SharedData) => void;
  /** Chatroom ID set by CreateChat after a successful create — ChatWindow reads and auto-opens it */
  pendingNewChatroomId: string | null;
  setPendingNewChatroomId: (id: string | null) => void;
}

export const createSharedSlice: StateCreator<SharedSlice, [], [], SharedSlice> = (set) => ({
  shared: {
    accessToken: '',
    residentId: '',
    facilityId: '',
    userId: '',
    ssoId: '',
  },
  setSharedData: (data) => set({ shared: data }),
  pendingNewChatroomId: null,
  setPendingNewChatroomId: (id) => set({ pendingNewChatroomId: id }),
});
